
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Tests if a value is falsy.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating whether a value is falsy
*
* @example
* var bool = isFalsy( false );
* // returns true
*
* @example
* var bool = isFalsy( null );
* // returns true
*
* @example
* var bool = isFalsy( '' );
* // returns true
*
* @example
* var bool = isFalsy( 0 );
* // returns true
*
* @example
* var bool = isFalsy( void 0 );
* // returns true
*
* @example
* var bool = isFalsy( NaN );
* // returns true
*
* @example
* var bool = isFalsy( [] );
* // returns false
*/
function isFalsy( value ) {
	return ( value ) ? false : true; // eslint-disable-line no-unneeded-ternary
}


// EXPORTS //
export default isFalsy;
